import aboutImage from "@/assets/about.webp";
import blogImage from "@/assets/blog.webp";
import burnabyImage from "@/assets/burnaby.webp";
import coquitlamImage from "@/assets/coquitlam.webp";
import customImage from "@/assets/custom.webp";
import custom1Image from "@/assets/custom1.webp";
import faqImage from "@/assets/faq.webp";
import langleyImage from "@/assets/langley.webp";
import maintanceImage from "@/assets/maintance.webp";
import northImage from "@/assets/north.webp";
import rdspImage from "@/assets/rdsp.webp";
import richmondImage from "@/assets/richmond.webp";
import seoImage from "@/assets/seo.webp";
import serviceImage from "@/assets/service.webp";
import socialImage from "@/assets/social.webp";
import surreyImage from "@/assets/surrey.webp";
import website1Image from "@/assets/website1.webp";

export const SEO_DATA = {
  // =====================================================
  // HOME PAGE
  // =====================================================

  home: {
    title: "Best Digital Agency in Vancouver | Square Trigger",

    description:
      "Boost your Business with Square Trigger, the best Digital agency in Vancouver, specializing in Website development and Search Engine Optimization and more.",

    keywords: ["Digital Agency in Vancouver"],

    ogTitle:
      "Best Digital Agency in Vancouver | Square Trigger",

    ogDescription:
      "Boost your Business with Square Trigger, the best Digital agency in Vancouver, specializing in Website development and Search Engine Optimization and more.",

    ogImage:
  "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&h=630&q=85",

    ogType: "website",
  },

  // =====================================================
  // SERVICES OVERVIEW
  // =====================================================

  services: {
    title:
      "Get Complete Digital solutions services for your business | Square Trigger",

    description:
      "Find Comprehensive Digital solutions services to transform your business in today's fast-moving market. Request a Free Quote.",

    keywords: ["Digital solutions"],

    ogTitle:
      "Get Complete Digital solutions services for your business | Square Trigger",

    ogDescription:
      "Find Comprehensive Digital solutions services to transform your business in today's fast-moving market. Request a Free Quote.",

    ogImage: serviceImage,

    ogType: "website",
  },

  // =====================================================
  // WEBSITE DEVELOPMENT
  // =====================================================

  websiteDevelopment: {
    title:
      "Top website development company in vancouver | Square Trigger",

    description:
      "Best website design and development company in Vancouver. We design high-performance websites for small to mid-sized businesses in Canada. Read more.",

    keywords: [
      "website development company",
      "Best website design and development company",
    ],

    ogTitle:
      "Top website development company in vancouver | Square Trigger",

    ogDescription:
      "The best website design and development company in Vancouver. We design high-performance websites for small to mid-sized businesses in Canada. Read more.",

    ogImage: website1Image,

    ogType: "website",
  },

  // =====================================================
  // CUSTOM TOOL CREATION
  // =====================================================

  customToolCreation: {
    title:
      "Custom Web Application Development Company in Vancouver",

    description:
      "We provide Custom Web Application Development that is suitable for your business. Get a Bespoke solution today.",

    keywords: ["Custom Web Application Development"],

    ogTitle:
      "Custom Web Application Development Company in Vancouver",

    ogDescription:
      "We provide Custom Web Application Development that is suitable for your business. Get a Bespoke solution today",

    ogImage: customImage,

    ogType: "website",
  },

  // =====================================================
  // SEO SERVICES
  // =====================================================

  seoServices: {
    title:
      "Best Search Engine Optimization Service | Square Trigger",

    description:
      "Get Affordable SEO services in Canada that help improve your Google ranking and drive more traffic and revenue. Start ranking higher today.",

    keywords: [
      "Search Engine Optimization Service",
      "Affordable SEO services in Canada",
    ],

    ogTitle:
      "Best Search Engine Optimization Service | Square Trigger",

    ogDescription:
      "Get Affordable SEO services in Canada that help improve your Google ranking and drive more traffic and revenue. Start ranking higher today.",

    /*
     * The image column in the document says social.webp,
     * but the actual SEO Open Graph block says seo.webp.
     */
    ogImage: seoImage,

    ogType: "website",
  },

  // =====================================================
  // SOCIAL MEDIA MARKETING
  // =====================================================

  socialMediaMarketing: {
    title:
      "Best Social Media Management Agency | Square Trigger",

    description:
      "Get Social Media Marketing services, including paid advertising strategies, to be ahead of your competitors. Establish a strong, recognizable presence today.",

    keywords: [
      "Best social media marketing agency",
      "Social Media Marketing services",
    ],

    ogTitle:
      "Best Social Media Management Agency | Square Trigger",

    ogDescription:
      "Get Social Media Marketing services, including paid advertising strategies, to be ahead of your competitors. Establish a strong, recognizable presence today.",

    ogImage: socialImage,

    ogType: "website",
  },

  // =====================================================
  // MAINTENANCE SUPPORT
  // =====================================================

  maintenanceSupport: {
    title:
      "Website Maintenance Support in Vancouver | Square Trigger",

    description:
      "Get best-in-class Website support and maintenance services for optimal performance to provide 99.9% uptime of your Website. Request a Maintenance Quote now.",

    keywords: [
      "website maintenance support",
      "website support and maintenance services",
    ],

    ogTitle:
      "Website Maintenance Support in Vancouver | Square Trigger",

    ogDescription:
      "Get best-in-class Website support and maintenance services for optimal performance to provide 99.9% uptime of your Website. Request a Maintenance Quote now.",

    /*
     * Confirm that this exact spelling exists:
     * src/assets/maintance.webp
     */
    ogImage: maintanceImage,

    ogType: "website",
  },

  // =====================================================
  // ABOUT
  // =====================================================

  about: {
    title: "About | Square Trigger",

    description:
      "Know more about Square Trigger to get exceptional Digital Agency services in Vancouver and throughout Canada. Read more.",

    keywords: ["digital agency"],

    ogTitle: "About | Square Trigger",

    ogDescription:
      "Know more about Square Trigger to get exceptional Digital Agency services in Vancouver and throughout Canada. Read more.",

    ogImage: aboutImage,

    ogType: "website",
  },

  // =====================================================
  // CONTACT
  // The company Open Graph document did not provide
  // separate approved Contact Open Graph values.
  // SEO.jsx will fall back to title and description.
  // =====================================================

  contact: {
    title: "Contact Digital Agency |Square Trigger",

    description:
      "Get the best digital services. Contact Square Trigger now to transform your digital presence. Get in touch now.",

    keywords: ["digital agency"],
  },

  // =====================================================
  // FAQ
  // =====================================================

  faqs: {
    title:
      "Digital Agency FAQs: Answers to Top Questions | Square Trigger",

    description:
      "Find answers to the most Frequently Asked Questions about our Digital Agency's complete services, pricing, and more. Read more.",

    keywords: ["digital agency"],

    ogTitle:
      "Digital Agency FAQs: Answers to Top Questions | Square Trigger",

    ogDescription:
      "Find answers to the most Frequently Asked Questions about our Digital Agency's complete services, pricing, and more. Read more.",

    ogImage: faqImage,

    ogType: "website",
  },

  // =====================================================
  // BLOG LISTING
  // =====================================================

  blog: {
    title:
      "Square Trigger Blogs | digital agency in vancouver",

    description:
      "Read about the latest blogs in website development, custom web application development , digital marketing, and more.",

    keywords: [
      "website development",
      "custom web application development",
    ],

    ogTitle:
      "Square Trigger Blogs | digital agency in vancouver",

    ogDescription:
      "Read about the latest blogs in website development, custom web application development , digital marketing, and more.",

    ogImage: "https://squaretrigger.com/blog.webp",

    ogType: "website",
  },

  // =====================================================
  // WORK
  // Company-approved Open Graph values.
  // =====================================================

  work: {
    title:
      "Explore the Digital solutions case studies |Square Trigger",

    description:
      "Discover how Square Trigger builds websites, custom tools, provides SEO and social strategies that solve business challenges. Let's Build Your Success Story!",

    keywords: ["Digital solutions", "Custom tools"],

    ogTitle:
      "Explore the Digital solutions case studies |Square Trigger",

    ogDescription:
      "Discover how Square Trigger builds websites, custom tools, provides SEO and social strategies that solve business challenges. Let's Build Your Success Story!",

    ogImage:
      "https://squaretrigger.com/static/media/work.e5f83cf6317904024d5c.webp",

    ogType: "website",
  },

  // =====================================================
  // GET STARTED
  // Company-approved Open Graph values.
  // =====================================================

  getStarted: {
    title:
      "Get started with the Digital solutions project| Square Trigger",

    description:
      "Get a free consultation by quickly filling out the form for web development, seo service and more. Watch how we tailor your goal & help you grow your business.",

    keywords: [
      "Digital solutions",
      "web development",
      "seo services",
    ],

    ogTitle:
      "Get started with the Digital solutions project| Square Trigger",

    ogDescription:
      "Get a free consultation by quickly filling out the form for web development, seo service and more. Watch how we tailor your goal & help you grow your business.",

    ogImage:
      "https://squaretrigger.com/static/media/logoc.95036e367bcac08f7505.webp",

    ogType: "website",
  },

  // =====================================================
  // RDSP TOOL
  // =====================================================

  rdspTool: {
    title:
      "RDSP Tool for Financial Advisors & Insurance Agents | Square Trigger",

    description:
      "We built a custom RDSP calculator tool for insurance agents and financial advisors in Canada. See how it works — and how we can build one for your brokerage.",

    ogTitle:
      "RDSP Tool for Financial Advisors & Insurance Agents | Square Trigger",

    ogDescription:
      "We built a custom RDSP calculator tool for insurance agents and financial advisors in Canada. See how it works — and how we can build one for your brokerage.",

    ogImage: rdspImage,

    ogType: "website",
  },

  // =====================================================
  // CUSTOM DASHBOARD
  // =====================================================

  customDashboard: {
    title:
      "Custom Dashboard Development Vancouver | Square Trigger",

    description:
      "We build custom admin dashboards and web applications for businesses that are done managing operations manually. See what we built for a Langley automotive brand.",

    ogTitle:
      "Custom Dashboard Development Vancouver | Square Trigger",

    ogDescription:
      "We build custom admin dashboards and web applications for businesses that are done managing operations manually. See what we built for a Langley automotive brand.",

    ogImage: custom1Image,

    ogType: "website",
  },

  // =====================================================
  // LOCATION — SURREY
  // =====================================================

  surrey: {
    title:
      "Top Digital Marketing  Agency in Surrey BC | Square Trigger",

    description:
      "Square Trigger is a Top Digital Marketing Agency in Surrey,BC. We build websites, SEO strategies, social media advertising, and custom tools for businesses.",

    ogTitle:
      "Top Digital Marketing  Agency in Surrey BC | Square Trigger",

    ogDescription:
      "Square Trigger is a Top Digital Marketing Agency in Surrey,BC. We build websites, SEO strategies, social media advertising, and custom tools for businesses.",

    ogImage: surreyImage,

    ogType: "website",
  },

  // =====================================================
  // LOCATION — BURNABY
  // =====================================================

  burnaby: {
    title:
      "Digital Marketing Agency in Burnaby BC | Square Trigger",

    description:
      "Square Trigger is a Digital Marketing  Agency in Burnaby BC. We build Websites, SEO strategies, Social media advertising, and Custom tools for businesses.",

    ogTitle:
      "Digital Marketing Agency in Burnaby BC | Square Trigger",

    ogDescription:
      "Square Trigger is a Digital Marketing  Agency in Burnaby BC. We build Websites, SEO strategies, Social media advertising, and Custom tools for businesses.",

    ogImage: burnabyImage,

    ogType: "website",
  },

  // =====================================================
  // LOCATION — RICHMOND
  // =====================================================

  richmond: {
    title:
      "Digital Marketing agency richmond | Square Trigger",

    description:
      "Square Trigger is a Digital Marketing Agency in Richmond, BC. We build Websites, SEO strategies, Social media advertising, and Custom tools for businesses.",

    ogTitle:
      "Digital Marketing agency richmond | Square Trigger",

    ogDescription:
      "Square Trigger is a Digital Marketing Agency in Richmond, BC. We build Websites, SEO strategies, Social media advertising, and Custom tools for businesses.",

    ogImage: richmondImage,

    ogType: "website",
  },

  // =====================================================
  // LOCATION — NORTH VANCOUVER
  // =====================================================

  northVancouver: {
    title:
      "Top Digital agency in North Vancouver | Square Trigger",

    description:
      "Square Trigger is a Digital marketing agency in North Vancouver. We build websites, seo strategies, social media advertising, and custom tools for businesses.",

    ogTitle:
      "Top Digital agency in North Vancouver | Square Trigger",

    ogDescription:
      "Square Trigger is a Digital marketing agency in North Vancouver. We build websites, seo strategies, social media advertising, and custom tools for businesses.",

    ogImage: northImage,

    ogType: "website",
  },

  // =====================================================
  // LOCATION — COQUITLAM
  // =====================================================

  coquitlam: {
    title:
      "Top Digital Marketing Agency in Coquitlam BC | Square Trigger",

    description:
      "Square Trigger is a Digital marketing agency in Coquitlam, BC. We build Websites, SEO strategies, social media advertising, and custom tools for businesses.",

    ogTitle:
      "Top Digital Marketing Agency in Coquitlam BC | Square Trigger",

    ogDescription:
      "Square Trigger is a Digital marketing agency in Coquitlam, BC. We build Websites, SEO strategies, social media advertising, and custom tools for businesses.",

    ogImage: coquitlamImage,

    ogType: "website",
  },

  // =====================================================
  // LOCATION — LANGLEY
  // =====================================================

  langley: {
    title:
      "Top Digital Marketing Agency in Langley BC | Square Trigger",

    description:
      "Square Trigger is a Digital Marketing Agency in Langley,  BC. We build Websites, SEO strategies, Social Media Advertising, and Custom tools for businesses.",

    ogTitle:
      "Top Digital Marketing Agency in Langley BC | Square Trigger",

    ogDescription:
      "Square Trigger is a Digital Marketing Agency in Langley,  BC. We build Websites, SEO strategies, Social Media Advertising, and Custom tools for businesses.",

    ogImage: langleyImage,

    ogType: "website",
  },

  process: {
    title: "Our Digital Project Process | Square Trigger",
    description: "See how Square Trigger plans, designs, develops, tests, and supports digital projects that deliver measurable business results.",
    ogImage: serviceImage,
    ogType: "website",
  },

  values: {
    title: "Our Values and Mission | Square Trigger",
    description: "Discover the values, mission, and client-first principles that guide every digital solution Square Trigger delivers.",
    ogImage: aboutImage,
    ogType: "website",
  },

  careers: {
    title: "Digital Agency Careers | Square Trigger",
    description: "Explore career opportunities at Square Trigger and join a collaborative team building high-impact digital experiences for Canadian businesses.",
    ogImage: aboutImage,
    ogType: "website",
  },

  caseStudies: {
    title: "Digital Project Case Studies | Square Trigger",
    description: "Explore Square Trigger case studies and see how our websites, custom applications, and digital strategies create measurable results.",
    ogImage: custom1Image,
    ogType: "website",
  },

  gallery: {
    title: "Digital Project Gallery | Square Trigger",
    description: "Browse a selection of website, e-commerce, custom application, branding, and digital marketing work by Square Trigger.",
    ogImage: custom1Image,
    ogType: "website",
  },

  testimonials: {
    title: "Client Testimonials | Square Trigger",
    description: "Read what clients say about working with Square Trigger on website development, SEO, custom tools, and digital marketing.",
    ogImage: serviceImage,
    ogType: "website",
  },

  freeResources: {
    title: "Free Digital Business Resources | Square Trigger",
    description: "Download free website, SEO, social media, e-commerce, branding, and performance resources from Square Trigger.",
    ogImage: faqImage,
    ogType: "website",
  },

  news: {
    title: "Square Trigger News and Press",
    description: "Read the latest company news, announcements, partnerships, and updates from Square Trigger.",
    ogImage: blogImage,
    ogType: "website",
  },

  privacyPolicy: {
    title: "Privacy Policy | Square Trigger",
    description: "Check how Square Trigger gathers, uses, and protects your personal information when you use our website and services.",
    ogImage: aboutImage,
    ogType: "website",
  },

  termsOfService: {
    title: "Terms of Service | Square Trigger",
    description: "Read Square Trigger's terms of service to understand the rules, responsibilities, and conditions for using our website and services.",
    ogImage: aboutImage,
    ogType: "website",
  },

};

// =====================================================
// INDIVIDUAL BLOG OPEN GRAPH DATA
// =====================================================

export const BLOG_SEO_BY_ID = {
  /*
   * BLOG 1
   *
   * Important:
   * The company Open Graph document provides a traffic-related
   * ogTitle for this maintenance article. It is preserved below
   * exactly as the provided Open Graph value.
   */
  "what-does-website-maintenance-include": {
    title:
      "Know What the Website Maintenance Services actually include | Square Trigger",

    description:
      "A Guide to website support and maintenance package- what is included, its impact on SEO, and the cost of the package. Update your website today.",

    keywords: [
      "Website Maintenance Services",
      "website support and maintenance package",
    ],

    ogTitle:
      "The best ways to increase website traffic  | Square Trigger",

    ogDescription:
      "A Guide to website support and maintenance package- what is included, its impact on SEO, and the cost of the package. Update your website today.",

    ogImage:
      "https://blog.squaretrigger.com/wp-content/uploads/2026/05/Website-maintenance-checklist-1.png",

    ogType: "article",

    structuredData: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://squaretrigger.com/blog/what-does-website-maintenance-include",
      },
      headline: "What Does Website Maintenance Include?",
      description:
        "Your website is not a one-time project. It is a business asset that needs to be maintained, updated, and protected consistently. If you are a business owner in Vancouver trying to figure out what a Website Maintenance Services package actually covers, this article is for you.",
      image:
        "https://blog.squaretrigger.com/wp-content/uploads/2026/05/Website-maintenance-checklist-1.png",
      author: {
        "@type": "Organization",
        name: "Square Trigger Team",
        url: "https://squaretrigger.com/",
      },
      publisher: {
        "@type": "Organization",
        name: "Square Trigger",
        logo: {
          "@type": "ImageObject",
          url: "https://squaretrigger.com/static/media/logoc.95036e367bcac08f7505.webp",
        },
      },
      datePublished: "2026-05-04",
    },
  },

  // =====================================================
  // BLOG 2
  // =====================================================

  "how-to-increase-site-traffic-practical-guide-for-service-businesses-in-vancouver":
    {
      title:
        "The best ways to increase website traffic | Square Trigger",

      description:
        "Learn the best ways to increase website traffic, the core technical factors that affect it, and the best link building strategies. Increase the conversion rate today.",

      keywords: [
        "Best ways to increase website traffic",
        "best link-building strategies",
      ],

      ogTitle:
        "The best ways to increase website traffic | Square Trigger",

      ogDescription:
        "Learn the best ways to increase website traffic, the core technical factors that affect it, and the best link building strategies. Increase the conversion rate today.",

      ogImage:
        "https://blog.squaretrigger.com/wp-content/uploads/2026/05/WEBSITE-TRAFFIC.png",

      ogType: "article",

      structuredData: {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": "https://squaretrigger.com/blog/how-to-increase-site-traffic-practical-guide-for-service-businesses-in-vancouver",
        },
        headline:
          "How to Increase Site Traffic: Practical Guide for Service Businesses in Vancouver",
        description:
          "Most businesses that come to us have tried something to grow their website traffic. A blog here, some social posts there. Maybe a Google Ads campaign that burned through the budget without much to show for it. The problem is rarely effort and direction.",
        image:
          "https://blog.squaretrigger.com/wp-content/uploads/2026/05/WEBSITE-TRAFFIC.png",
        author: {
          "@type": "Organization",
          name: "Square Trigger Team",
          url: "https://squaretrigger.com/",
        },
        publisher: {
          "@type": "Organization",
          name: "Square Trigger",
          logo: {
            "@type": "ImageObject",
            url: "https://squaretrigger.com/static/media/logoc.95036e367bcac08f7505.webp",
          },
        },
        datePublished: "2026-05-04",
      },
    },

  // =====================================================
  // BLOG 3
  // =====================================================

  "how-seo-services-drive-success-across-key-industries": {
    title:
      "Learn how professional search engine optimization services drive success",

    description:
      "Know the best SEO strategies that drive sales, the things to look for in an SEO agency, and the importance of local SEO services that firms actually need.",

    keywords: [
      "Professional Search Engine Optimization Service",
      "SEO strategies",
      "local SEO services",
    ],

    ogTitle:
      "Learn how professional search engine optimization services drive success",

    ogDescription:
      "Know the best SEO strategies that drive sales, the things to look for in an SEO agency, and the importance of local SEO services that firms actually need.",

    ogImage:
      "https://blog.squaretrigger.com/wp-content/uploads/2026/05/SEO-SERVICES-5.png",

    ogType: "article",

    structuredData: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://squaretrigger.com/blog/how-seo-services-drive-success-across-key-industries",
      },
      headline: "How SEO Services Drive Success Across Key Industries",
      description:
        "Most businesses know they need SEO services. Fewer understand why the industry they operate in, changes everything about how SEO should work. A law firm and a car dealership are both service businesses. Both need to be found on Google. But the buyer’s journey is completely different, the trust signals are different, the keywords are different, and the content that converts is different. If you apply the same generic SEO strategy to both, you will get average results for neither.",
      image:
        "https://blog.squaretrigger.com/wp-content/uploads/2026/05/SEO-SERVICES-5.png",
      author: {
        "@type": "Organization",
        name: "Square Trigger Team",
        url: "https://squaretrigger.com/",
      },
      publisher: {
        "@type": "Organization",
        name: "Square Trigger",
        logo: {
          "@type": "ImageObject",
          url: "https://squaretrigger.com/static/media/logoc.95036e367bcac08f7505.webp",
        },
      },
      datePublished: "2026-05-04",
    },
  },

  // =====================================================
  // BLOG 4
  // =====================================================

  "how-to-improve-local-search-ranking-the-complete-2026-guide": {
    title:
      "Improve Local Search Ranking to improve website visibility in 2026 | Square Trigger",

    description:
      "Check how you can improve local search ranking with practical local SEO strategies to enhance online presence and attract nearby customers. Read more.",

    keywords: [
      "improve website visibility",
      "enhance online presence",
    ],

    ogTitle:
      "Improve Local Search Ranking to improve website visibility in 2026 | Square Trigger",

    ogDescription:
      "Check how you can improve local search ranking with practical local SEO strategies to enhance online presence and attract nearby customers. Read more.",

    ogImage:
      "https://blog.squaretrigger.com/wp-content/uploads/2026/08/Improve-Local-Search-ranking.png",

    ogType: "article",

    structuredData: {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://squaretrigger.com/blog/how-to-improve-local-search-ranking-the-complete-2026-guide",
      },
      headline: "Improve Local Search Ranking to improve website visibility in 2026 | Square Trigger",
      description:
        "Check how you can improve local search ranking with practical local SEO strategies to enhance online presence and attract nearby customers. Read more.",
      image:
        "https://blog.squaretrigger.com/wp-content/uploads/2026/08/Improve-Local-Search-ranking.png",
      author: {
        "@type": "Organization",
        name: "Square Trigger Team",
        url: "https://squaretrigger.com/",
      },
      publisher: {
        "@type": "Organization",
        name: "Square Trigger",
        logo: {
          "@type": "ImageObject",
          url: "https://squaretrigger.com/static/media/logoc.95036e367bcac08f7505.webp",
        },
      },
      datePublished: "2026-08-23",
    },
  },
};

/*
 * Temporary backward compatibility for pages that may
 * still import SEO_KEYWORDS.
 */
export const SEO_KEYWORDS = Object.fromEntries(
  Object.entries(SEO_DATA).map(([key, value]) => [
    key,
    value.keywords || [],
  ])
);
